/**
 * QZ Tray HID device abstraction.
 * Wraps qz.hid for listing, claiming, streaming, and releasing USB HID devices
 * (barcode scanners in HID mode).
 */
import qz from 'qz-tray';

export async function listarDispositivos() {
  try {
    if (!qz.websocket.isActive()) return [];
    const devices = await qz.hid.listDevices();
    return Array.isArray(devices) ? devices : [];
  } catch (err) {
    console.error('[QZ HID] Error al listar dispositivos:', err?.message || err);
    return [];
  }
}

export async function reclamarDispositivo(vendorId, productId) {
  try {
    if (!qz.websocket.isActive()) {
      console.warn('[QZ HID] WebSocket inactivo');
      return false;
    }
    await qz.hid.claimDevice({ vendorId, productId });
    console.log(`[QZ HID] Dispositivo ${vendorId}:${productId} reclamado`);
    return true;
  } catch (err) {
    console.error(`[QZ HID] Error al reclamar ${vendorId}:${productId}:`, err?.message || err);
    return false;
  }
}

export async function abrirStream(vendorId, productId, opciones = {}) {
  try {
    if (!qz.websocket.isActive()) return false;
    await qz.hid.openStream({ vendorId, productId, ...opciones });
    console.log(`[QZ HID] Stream abierto para ${vendorId}:${productId}`);
    return true;
  } catch (err) {
    console.error(`[QZ HID] Error al abrir stream ${vendorId}:${productId}:`, err?.message || err);
    return false;
  }
}

export async function cerrarStream(vendorId, productId) {
  try {
    if (!qz.websocket.isActive()) return;
    await qz.hid.closeStream({ vendorId, productId });
    console.log(`[QZ HID] Stream cerrado para ${vendorId}:${productId}`);
  } catch (err) {
    console.error(`[QZ HID] Error al cerrar stream ${vendorId}:${productId}:`, err?.message || err);
  }
}

export async function liberarDispositivo(vendorId, productId) {
  try {
    if (!qz.websocket.isActive()) return;
    await qz.hid.releaseDevice({ vendorId, productId });
    console.log(`[QZ HID] Dispositivo ${vendorId}:${productId} liberado`);
  } catch (err) {
    console.error(`[QZ HID] Error al liberar ${vendorId}:${productId}:`, err?.message || err);
  }
}

export function setCallbackHid(fn) {
  qz.hid.setHidCallbacks(fn);
}

const qzHidService = {
  listarDispositivos,
  reclamarDispositivo,
  abrirStream,
  cerrarStream,
  liberarDispositivo,
  setCallbackHid,
};

export default qzHidService;
